module.exports = __webpack_public_path__ + "img/293534_B2BFC5_738289_8A9AA7-256px.7ca4b409.png";